import AttributeInputInserter from './mixins/attribute-input-inserter';
import TrackedCaret from './mixins/tracked-caret';
import ComponentPositioningMixin from '@intercom/embercom-composer/components/mixins/component-positioning';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import { normalizeEvent } from '@intercom/embercom-composer/lib/normalize-event';
import $ from 'jquery';
import { alias, and, equal, notEmpty } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(AttributeInputInserter, TrackedCaret, ComponentPositioningMixin, {
  editorValuePath: 'value',
  classNames: ['popup-inserter-row', 'popup-inserter-row-uses-flexbox', 'o__has-columns'],
  focusIfEmpty: false,
  isEmpty: equal('value', ''),
  shouldAutoFocus: and('isEmpty', 'focusIfEmpty'),
  label: null,
  hasLabel: notEmpty('label'),
  hasError: false,
  tooltip: null,
  hasTooltip: notEmpty('tooltip'),
  placeholder: 'Type something',
  value: '',
  canDelete: false,
  canInsertAttributes: false,
  isInputDisabled: false,
  showInsertAttributeButton: alias('canInsertAttributes'),
  didInsertElement() {
    this._super(...arguments);
    schedule('afterRender', this, function () {
      if (this.get('shouldAutoFocus')) {
        focusInput($('input:first', this.element));
      }
    });
  },
  willDestroyElement() {
    this._super(...arguments);
    $('input:first', this.element).off();
  },
  inputHasError: Em.on('didInsertElement', Em.observer({
    dependentKeys: ['hasError'],
    fn() {
      if (this.get('hasError')) {
        $(this.element).parent().addClass('has-input-error');
      } else {
        $(this.element).parent().removeClass('has-input-error');
      }
    },
    sync: true
  })),
  paste(event) {
    let nativeEvent = normalizeEvent(event);
    nativeEvent.preventDefault();
    let clipboardData = nativeEvent.clipboardData || window.clipboardData;
    let text = clipboardData.getData('text/plain') || clipboardData.getData('Text');
    this.setCaretPosition();
    this.addTextAtCaretPosition(text);
  },
  addTextAtCaretPosition(text) {
    let position = this.get('caretPosition');
    let inputValue = this.get('value');
    let endPosition = this.get('caretEndPosition');
    inputValue = inputValue.substr(0, position) + text + inputValue.substr(endPosition);
    this.set('value', inputValue);
  },
  actions: {
    delete() {
      this.delete?.();
    },
    onEnter() {
      this.onEnter?.(this.get('value'));
    }
  },
  positionAttributeInserter: Em.observer({
    dependentKeys: ['showAttributeInserter'],
    fn() {
      let $attributeInserter;
      if (this.get('showAttributeInserter')) {
        schedule('afterRender', this, function () {
          $attributeInserter = $('.attribute-selector-for-input', this.element);
          let top = parseInt($attributeInserter.css('top'), 10);
          let verticalOffset = this._verticalOffsetForOverflowParent(top, $attributeInserter);
          let position = $(this.element).position();
          let height = $(this.element).height();
          this.positionPointer(verticalOffset);
          $attributeInserter.css('top', top += verticalOffset + position.top + height / 2);
        });
      }
    },
    sync: true
  })
});